import React, { useMemo } from "react";

import { PECScanData as PECScanDataModel } from "../../../../utils/models";
import { concatClassNames, getChunkedData } from "../../../../utils/utilities";

import CustomSection from "../../../custom-reports/custom-general/custom-section";
import CustomPecScanTable from "../../../custom-reports/custom-pec/custom-pec-scan-table";

import usePecScanOverview from "../../../../hooks/usePecScanOverview";
import classNames from "../pdf.module.scss";
import Conditional from "../../../common/conditional";

const PECScanDataSummary: React.FC<PECScanDataModel> = (props) => {
  const summaryData = usePecScanOverview()(props);

  const chunkedSummary = useMemo(() => {
    return getChunkedData(summaryData, 10);
  }, [summaryData]);

  return (
      <React.Fragment >
        <Conditional isVisible={chunkedSummary.length > 0}>
          {chunkedSummary.map((summary, index) => (
            <CustomSection key={index} sectionTitle="Data Sheet" sectionSubtitle={`Scan Data (${props.sectionName} Summary)`}>
                  <div className={classNames.pecScanTable}>
                    <div className="p-2">
                        <CustomPecScanTable data={summary} />

                          <div className={concatClassNames([classNames.pecScan, 'mt-2 '])}>
                              <div className={classNames.pecScanTitle}>Remarks</div>
                              <div className={classNames.pecScanBody}>{props.remarks}</div>
                          </div>
                    </div>
                  </div>
            </CustomSection>
          ))}
        </Conditional>
        
        <Conditional isVisible={chunkedSummary.length === 0}>
          <CustomSection sectionTitle="Data Sheet" sectionSubtitle={`Scan Data (${props.sectionName} Summary)`}>
                <div className={classNames.pecScanTable}>
                  <div className="p-2">
                      <CustomPecScanTable data={summaryData} />

                        <div className={concatClassNames([classNames.pecScan, 'mt-2 '])}>
                            <div className={classNames.pecScanTitle}>Remarks</div>
                            <div className={classNames.pecScanBody}>{props.remarks}</div>
                        </div>
                  </div>
                </div>
          </CustomSection>
        </Conditional>
      </React.Fragment>
  );
};

export default PECScanDataSummary;